module.exports = __webpack_public_path__ + "img/thumbnail_BorneanOrangutan_m_normal.e0b8a304.png";